export default __webpack_public_path__ + "static/media/planner.7e78c46c.png";